import { IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { deleteStudentLang } from '@webapps/business';
import {
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AddLang from './AddLang';
import theme from './theme';

const {
  colors: { background },
} = theme;

const Language = ({ language = [], refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [addLang, setAddLang] = useState(false);

  const handleOpenAddLang = () => {
    setAddLang(true);
  };
  const handleCloseAddLang = () => {
    setAddLang(false);
  };

  const [visibleDelete, setVisibleDelete] = useState(true);

  const handleDeleteVisible = () => {
    setVisibleDelete(!visibleDelete);
  };

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteLang,
  } = useMutation(deleteStudentLang);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccessDelete]);

  const deleteLang = async (id) => {
    await mutateDeleteLang({
      id,
    });
  };

  const getLevelLabel = (level) => {
    if (level === 1) {
      return 'Débutant';
    }
    if (level === 2) {
      return 'Intermédiaire';
    }
    if (level === 3) {
      return 'Courant';
    }
    if (level === 4) {
      return 'Langue maternelle';
    }
    return 'Non reconnu';
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.language.title" />{' '}
          {language.length ? '(' + language.length + ')' : ''}
        </div>
        <div style={{ display: 'flex' }}>
          <IconButton
            onClick={handleOpenAddLang}
            size="small"
            style={{
              margin: 3,
              borderRadius: '20px',
              border: '1px solid #C0D9FF',
              backgroundColor: '#F3F7FF',
              width: '30px',
              display: 'flex',
              justifyContent: 'center',
              height: '30px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <AddIcon fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
          {language?.length > 0 && (
            <IconButton
              onClick={handleDeleteVisible}
              size="small"
              style={{
                margin: 3,
                borderRadius: '20px',
                border: '1px solid #C0D9FF',
                backgroundColor: '#F3F7FF',
                width: '30px',
                display: 'flex',
                justifyContent: 'center',
                height: '30px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              {visibleDelete ? (
                <EditIcon fontSize="inherit" style={{ color: '#5A6DA1' }} />
              ) : (
                <DoneIcon fontSize="inherit" style={{ color: '#5A6DA1' }} />
              )}
            </IconButton>
          )}
        </div>
      </div>
      {!language.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '190px',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <TableHeadCell
                  style={{
                    padding: 0,
                    textTransform: 'none',
                  }}

                  className={global.infoText}
                >
                  <FormattedMessage id="student.profil.language.table.nom" />
                </TableHeadCell>
                <TableHeadCell
                  style={{
                    padding: 0,
                    textTransform: 'none',
                  }}

                  className={global.infoText}
                >
                  <FormattedMessage id="student.profil.language.table.niveau" />
                </TableHeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {language?.map(({ id, label, level }, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{
                      padding: 0,
                      border: 'none',
                      color: '#152652',
                    }}
                    className={global.infoText}
                  >
                    {label}
                  </TableCell>
                  <TableCell
                    style={{
                      padding: 0,
                      border: 'none',
                      color: '#152652',
                    }}
                    className={global.infoText}
                  >
                    {getLevelLabel(level)}
                  </TableCell>
                  <TableCell
                    style={{
                      padding: 0,
                      border: 'none',
                    }}
                    className={global.infoText}
                  >
                    <IconButton
                      disabled={isLoadingDelete}
                      onClick={() => deleteLang(id)}
                      size="small"
                      style={{ color: '#152652' }}
                    >
                      <HighlightOffIcon
                        color="secondary"
                        style={{ opacity: visibleDelete ? 0 : 100 }}
                        fontSize="small"
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modal
        onCancel={handleCloseAddLang}
        open={addLang}
        title={<FormattedMessage id="addLang" />}
      >
        <AddLang close={handleCloseAddLang} refetch={refetch} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

Language.propTypes = {
  language: PropTypes.array,
  refetch: PropTypes.func,
};

export default Language;
